import TableDailyReport from './TableDailyReport';

export default TableDailyReport